import { isObjectEmpty, notEmpty, validatePhoneNumber, validateZipCode } from '@common/paymentsUtils/inputValidator';
import errorMessages from '@common/constants/errorMessages';

const fieldsMapping = {
  address1: {
    validatorFn: notEmpty,
    errorMessage: errorMessages.PAYMENT_BILLING_STREET_ADDRESS,
  },
  city: {
    validatorFn: notEmpty,
    errorMessage: errorMessages.PAYMENT_ADDRESS_CITY_EMPTY,
  },
  state: {
    validatorFn: notEmpty,
    errorMessage: errorMessages.PAYMENT_STATE_EMPTY,
  },
  zipCode: {
    validatorFn: validateZipCode,
    errorMessage: errorMessages.PAYMENT_ZIP_CODE_EMPTY,
  },
  phoneNumber: {
    validatorFn: validatePhoneNumber,
    errorMessage: errorMessages.PHONE_NUMBER_INVALID,
  },
};

const validateAllInputs = (ctx) => {
  const newState = ctx.state;
  const errors = {};

  Object.entries(fieldsMapping).forEach(([key, val]) => {
    const { validatorFn, errorMessage } = val;
    const inputIsValid = validatorFn(newState[key].value);

    if (!inputIsValid) {
      errors[key] = errorMessage;
      newState[key].error = errorMessage;
    } else {
      newState[key].error = '';
    }
  });

  ctx.setState(newState);

  if (!isObjectEmpty(errors)) {
    ctx.props.trackValidationError({ errors });
    return false;
  }
  return true;
};

export default validateAllInputs;
